import { useStrategy } from '../../hooks/useStrategy';
import ConditionBox from '../common/ConditionBox';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ConditionError from '../common/ConditionError';
import ConstantFilterWarning from '../common/ConstantFilterWarning';
import { isConditionWithErrors } from '../../filterQueryFormat/logic/LogicGroup';
import MatchStatusIcon from './MatchStatusIcon';
import styled from 'foundations-theming/utils';
import ViewerConditionDisplay from './ViewerConditionDisplay';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import ViewerConditionClickableBoxDeleteButton from './ViewerConditionClickableBoxDeleteButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ViewerConditionDisplayWrapper = styled.div.withConfig({
  displayName: "ViewerCondition__ViewerConditionDisplayWrapper",
  componentId: "qqwpam-0"
})(["word-break:break-word;"]);
const DeleteButtonWrapper = styled.div.withConfig({
  displayName: "ViewerCondition__DeleteButtonWrapper",
  componentId: "qqwpam-1"
})(["&&&{.delete-button-container{display:block;padding:0;position:static;width:22px;}}"]);
/**
 * Wrapper for FilterOperatorDisplay.
 *
 * Provides all necessary data and styling.
 */
const ViewerCondition = ({
  condition,
  conditionPath,
  parentLogicGroup,
  testFilterData,
  use = 'condition-box',
  filterFamily
}) => {
  const {
    draftCondition,
    isInEditMode,
    viewerConditionToDelete,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    isTestFiltersEnabled
  } = useStrategy();
  const isFilterBranchDeleteTriggered = // @ts-expect-error viewerConditionToDelete might be undefined
  conditionPath === null || conditionPath === void 0 ? void 0 : conditionPath.equals(viewerConditionToDelete);
  const isConditionOpenInEditor = Boolean(conditionPath && (draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath) && !(draftCondition !== null && draftCondition !== void 0 && draftCondition.isAddingNew) && conditionPath.equals(draftCondition.conditionPath));
  const showDeleteButtonForSinglePanel = conditionPath && isInEditMode && !isConditionOpenInEditor;
  const showDeleteButtonForTwoPanel = conditionPath && isInEditMode;
  const showDeleteButton = useOnePanel ? showDeleteButtonForSinglePanel : showDeleteButtonForTwoPanel;
  const operatorDisplay = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(ViewerConditionDisplayWrapper, {
        children: /*#__PURE__*/_jsx(ViewerConditionDisplay, {
          condition: condition,
          filterFamily: filterFamily,
          parentLogicGroup: parentLogicGroup,
          testFilterData: testFilterData
        })
      })
    }), isTestFiltersEnabled && testFilterData && /*#__PURE__*/_jsx(MatchStatusIcon, {
      matchStatus: testFilterData.status
    }), showDeleteButton && /*#__PURE__*/_jsx(DeleteButtonWrapper, {
      children: /*#__PURE__*/_jsx(ViewerConditionClickableBoxDeleteButton, {
        conditionPath: conditionPath,
        isFilterBranchDeleteTriggered: isFilterBranchDeleteTriggered
      })
    })]
  });
  const commonContent = /*#__PURE__*/_jsxs(_Fragment, {
    children: [operatorDisplay, /*#__PURE__*/_jsx(ConditionError, {
      condition: condition,
      showConditionErrors: true,
      spaceStyleProps: {
        marginBlockStart: '0'
      }
    }), /*#__PURE__*/_jsx(ConstantFilterWarning, {
      condition: condition
    })]
  });
  if (use === 'plain') {
    return /*#__PURE__*/_jsxs("div", {
      children: [commonContent, /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: condition,
        use: "banner-plain"
      })]
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    hasError: isConditionWithErrors(condition),
    size: "sm",
    children: [commonContent, /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition,
      use: "banner"
    })]
  });
};
export default ViewerCondition;